<template>
    <button class="button">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: "MainButton"
    }
</script>

<style scoped>
    .button {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #FFF;
        border: 1px solid #DCDFE6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        transition: .1s;
        font-weight: 500;
        /*padding: 12px 20px;*/
        font-size: 14px;
        border-radius: 4px;
        width: 120px;
        height: 35px;
    }
    .button:hover {
        background: #ff4e00;
        color: #ffffff;
    }
</style>
